// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/vendors." + "1d1c0a2cb30589a45f7d" + ".js";
};